import { render } from "./SlotItem.vue?vue&type=template&id=02b1f491"
import script from "./SlotItem.vue?vue&type=script&lang=js"
export * from "./SlotItem.vue?vue&type=script&lang=js"

import "./SlotItem.vue?vue&type=style&index=0&id=02b1f491&lang=scss"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__